module.exports = __webpack_public_path__ + "static/media/savant-admin.185c0783.png";